import * as i2 from '@angular/common';
import { formatDate as formatDate$1, CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { Injectable, EventEmitter, Directive, Input, Output, Component, ContentChildren, ViewEncapsulation, forwardRef, ViewChild, Inject, ChangeDetectionStrategy, NgModule } from '@angular/core';
import * as i1 from '@angular/forms';
import { NG_VALIDATORS, FormsModule } from '@angular/forms';
import * as i3$1 from '@angular/material/checkbox';
import { MatCheckboxModule } from '@angular/material/checkbox';
import * as i3$2 from '@angular/material/form-field';
import { MatFormFieldModule } from '@angular/material/form-field';
import * as i5 from '@angular/material/input';
import { MatInputModule } from '@angular/material/input';
import * as i1$2 from '@angular/material/radio';
import { MatRadioModule } from '@angular/material/radio';
import * as i6 from '@angular/material/datepicker';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { XpoChipsModule } from '@xpo-ltl/ngx-ltl-core/chips';
import * as i5$1 from '@xpo-ltl/ngx-ltl-core/button';
import { XpoButtonModule } from '@xpo-ltl/ngx-ltl-core/button';
import * as i4 from '@xpo-ltl/ngx-ltl-core/datepicker';
import { XpoDatePickerModule } from '@xpo-ltl/ngx-ltl-core/datepicker';
import * as i2$1 from '@xpo-ltl/ngx-ltl-core/dialog';
import { XpoDialogModule } from '@xpo-ltl/ngx-ltl-core/dialog';
import * as i3 from '@xpo-ltl/ngx-ltl-core/icon';
import { XpoIconModule } from '@xpo-ltl/ngx-ltl-core/icon';
import { cloneDeep } from '@xpo-ltl/ngx-ltl-core/utils';
import * as i1$1 from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as i6$1 from '@angular/material/button';
import * as i4$1 from '@angular/material/icon';

class XpoFacetFilterService {
    constructor() {
        this.filterCriteriaState = [];
    }
    updateFilterCriteria(objCustomFilter) {
        const filterCriteria = {
            [objCustomFilter.filterId]: {
                filter: {
                    filterType: objCustomFilter.type,
                    conditions: objCustomFilter.conditions,
                },
            },
        };
        const index = this.filterCriteriaState.findIndex((element) => Object.keys(element)[0] === objCustomFilter.filterId);
        if (index >= 0) {
            this.filterCriteriaState.splice(index, 1);
        }
        if (!objCustomFilter.invalid) {
            this.filterCriteriaState.push(filterCriteria);
        }
    }
    getFilterCriteria() {
        return this.filterCriteriaState;
    }
}
XpoFacetFilterService.ɵfac = function XpoFacetFilterService_Factory(t) { return new (t || XpoFacetFilterService)(); };
XpoFacetFilterService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: XpoFacetFilterService, factory: XpoFacetFilterService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoFacetFilterService, [{
        type: Injectable
    }], null, null); })();

const XPO_FACET_FILTER_ERROR_CONSTANTS = {
    missingFilterId: '[ngxltl-core] filterID property not defined',
};

class XpoFilterControlBaseComponent {
    constructor() {
        // If not filterModel set, control will take data from source.
        this.allowInferDataFromSource = true;
        this.valueChanged = new EventEmitter();
        this.removeFilter = new EventEmitter();
        this.hideTitleSection = false;
        this.parentSectionName = '';
    }
    get typeComponentControl() {
        return this.typeControl;
    }
    ngOnInit() {
        this.originalFilterModel = this.filterModel;
    }
    checkInit() {
        if (!this.filterId) {
            console.error(XPO_FACET_FILTER_ERROR_CONSTANTS.missingFilterId);
        }
    }
    onValueChanged(value, controlCriteria) {
        this.valueChanged.emit({ value: value, typeControl: this.typeControl, controlId: this.filterId, controlCriteria });
    }
    onReset() {
        this.removeFilter.emit();
        this.filterModel = this.originalFilterModel;
        this.applyFilter();
    }
    ;
    setModel(newValue) { }
    ;
    applyFilter() {
        this.onValueChanged(this.filterModel, this.mapFacetFilterControlToCriteria(this.filterModel));
    }
    isValidCondition() {
        return true;
    }
    ;
}
XpoFilterControlBaseComponent.ɵfac = function XpoFilterControlBaseComponent_Factory(t) { return new (t || XpoFilterControlBaseComponent)(); };
XpoFilterControlBaseComponent.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: XpoFilterControlBaseComponent, inputs: { filterId: "filterId", filterModel: "filterModel", allowInferDataFromSource: "allowInferDataFromSource" }, outputs: { valueChanged: "valueChanged", removeFilter: "removeFilter" } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoFilterControlBaseComponent, [{
        type: Directive
    }], function () { return []; }, { filterId: [{
            type: Input
        }], filterModel: [{
            type: Input
        }], allowInferDataFromSource: [{
            type: Input
        }], valueChanged: [{
            type: Output
        }], removeFilter: [{
            type: Output
        }] }); })();

function XpoFacetFilterSection_div_1_button_4_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 4);
    i0.ɵɵlistener("click", function XpoFacetFilterSection_div_1_button_4_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r3); const ctx_r2 = i0.ɵɵnextContext(2); return ctx_r2.onReset(); });
    i0.ɵɵtext(1, "Reset");
    i0.ɵɵelementEnd();
} }
function XpoFacetFilterSection_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "uppercase");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, XpoFacetFilterSection_div_1_button_4_Template, 2, 0, "button", 3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 2, ctx_r0.sectionName));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.showReset);
} }
const _c0$6 = ["*"];
class XpoFacetFilterSection {
    constructor() {
        this.controlSubscriptions = [];
        this.valueChanged = new EventEmitter();
        this.showTitle = true;
        this.showReset = false;
    }
    ngOnInit() { }
    ngOnDestroy() {
        if (this.controlSubscriptions.length) {
            this.controlSubscriptions.forEach((item) => item.unsubscribe());
        }
    }
    configComponent() {
        this.controls.forEach((control) => {
            const subscription = control.valueChanged.subscribe((event) => {
                this.valueChanged.emit(event);
                if (!event.controlCriteria.invalid) {
                    this.showReset = true;
                }
            });
            this.showTitle = !control.hideTitleSection;
            const subscriptionReset = control.removeFilter.subscribe(() => {
                this.showReset = false;
            });
            this.controlSubscriptions.push(subscription);
            this.controlSubscriptions.push(subscriptionReset);
            control.parentSectionName = this.sectionName;
            control.applyFilter();
        });
    }
    onReset() {
        this.controls.forEach((control) => control.onReset());
        this.showReset = false;
    }
    getSectionControlById(controlId) {
        return this.controls.find((control) => control.filterId === controlId);
    }
}
XpoFacetFilterSection.ɵfac = function XpoFacetFilterSection_Factory(t) { return new (t || XpoFacetFilterSection)(); };
XpoFacetFilterSection.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoFacetFilterSection, selectors: [["xpo-facet-filter-section"]], contentQueries: function XpoFacetFilterSection_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        i0.ɵɵcontentQuery(dirIndex, XpoFilterControlBaseComponent, 4);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.controls = _t);
    } }, inputs: { sectionName: "sectionName" }, outputs: { valueChanged: "valueChanged" }, ngContentSelectors: _c0$6, decls: 3, vars: 1, consts: [[1, "xpo-FacetFilter-section"], ["class", "xpo-FacetFilter-sectionTitle", 4, "ngIf"], [1, "xpo-FacetFilter-sectionTitle"], ["class", "xpo-FacetFilter-section-resetButton", 3, "click", 4, "ngIf"], [1, "xpo-FacetFilter-section-resetButton", 3, "click"]], template: function XpoFacetFilterSection_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, XpoFacetFilterSection_div_1_Template, 5, 4, "div", 1);
        i0.ɵɵprojection(2);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showTitle);
    } }, directives: [i2.NgIf], pipes: [i2.UpperCasePipe], styles: [".flex--stretch[_ngcontent-%COMP%]{flex:1}.xpo-FacetFilter-section[_ngcontent-%COMP%]{padding-bottom:20px}.xpo-FacetFilter-sectionTitle[_ngcontent-%COMP%]{display:flex;justify-content:space-between;font-size:1rem;color:#6f6f6f;padding-bottom:8px}.xpo-FacetFilter-section-resetButton[_ngcontent-%COMP%]{cursor:pointer;color:#1976d2;border:none;background:none}.xpo-FacetFilter-section-resetButton[_ngcontent-%COMP%]:hover{color:#0d47a1}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoFacetFilterSection, [{
        type: Component,
        args: [{
                selector: 'xpo-facet-filter-section',
                templateUrl: './filter-section.component.html',
                styleUrls: ['./filter-section.component.scss'],
            }]
    }], function () { return []; }, { controls: [{
            type: ContentChildren,
            args: [XpoFilterControlBaseComponent]
        }], sectionName: [{
            type: Input
        }], valueChanged: [{
            type: Output
        }] }); })();

var XpoFacetFilterStringOperators;
(function (XpoFacetFilterStringOperators) {
    XpoFacetFilterStringOperators["EQUAL"] = "equal";
    XpoFacetFilterStringOperators["CONTAINS"] = "contains";
})(XpoFacetFilterStringOperators || (XpoFacetFilterStringOperators = {}));
var XpoFacetFilterNumberOperators;
(function (XpoFacetFilterNumberOperators) {
    XpoFacetFilterNumberOperators["EQUAL"] = "equal";
    XpoFacetFilterNumberOperators["BETWEEN"] = "inRange";
    XpoFacetFilterNumberOperators["LESSERTHAN"] = "lesserThanOrEqual";
    XpoFacetFilterNumberOperators["GREATERTHAN"] = "greaterThanOrEqual";
})(XpoFacetFilterNumberOperators || (XpoFacetFilterNumberOperators = {}));
var XpoFacetFilterDateOperators;
(function (XpoFacetFilterDateOperators) {
    XpoFacetFilterDateOperators["EQUAL"] = "equal";
    XpoFacetFilterDateOperators["BETWEEN"] = "between";
    XpoFacetFilterDateOperators["LESSERTHAN"] = "lesserThanOrEqual";
    XpoFacetFilterDateOperators["GREATERTHAN"] = "greaterThanOrEqual";
})(XpoFacetFilterDateOperators || (XpoFacetFilterDateOperators = {}));
var XpoFacetFilterCombiner;
(function (XpoFacetFilterCombiner) {
    XpoFacetFilterCombiner["AND"] = "AND";
    XpoFacetFilterCombiner["OR"] = "OR";
})(XpoFacetFilterCombiner || (XpoFacetFilterCombiner = {}));
var XpoFacetFilterTypeOperator;
(function (XpoFacetFilterTypeOperator) {
    XpoFacetFilterTypeOperator["Number"] = "number";
    XpoFacetFilterTypeOperator["String"] = "string";
    XpoFacetFilterTypeOperator["Date"] = "date";
    XpoFacetFilterTypeOperator["XpoFacetFilterTimeValueOperator"] = "time";
})(XpoFacetFilterTypeOperator || (XpoFacetFilterTypeOperator = {}));

var XpoFacetFilterSortOptions;
(function (XpoFacetFilterSortOptions) {
    XpoFacetFilterSortOptions["ASC"] = "asc";
    XpoFacetFilterSortOptions["DESC"] = "desc";
})(XpoFacetFilterSortOptions || (XpoFacetFilterSortOptions = {}));

const DEFAULT_LOCALIZATION = 'en-US';
// TODO: See if we should replace this method with something else
const getUniqueFilterId = (size) => {
    const stringSize = size ? size : 5;
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    const charactersLength = characters.length;
    for (let i = 0; i < stringSize; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
};
const isDate = (date) => !isNaN(+new Date(date));
const sortItems = (sort, current, next) => sort === XpoFacetFilterSortOptions.ASC ? (current > next ? 1 : -1) :
    (sort === XpoFacetFilterSortOptions.DESC ? (current > next ? -1 : 1) : 0);
const formatDate = (date, format) => date && isDate(date) && formatDate$1(date, format, DEFAULT_LOCALIZATION);
const isNumber = (value) => value !== null && value !== undefined && !isNaN(+value);

function XpoFacetFilterComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵprojection(1);
    i0.ɵɵelementEnd();
} }
const _c0$5 = function (a0, a1) { return { "xpo-FacetFilter-menu--expanded": a0, "xpo-FacetFilter-menu--contracted": a1 }; };
const _c1$3 = ["*"];
class XpoFacetFilterComponent {
    constructor(facetService) {
        this.facetService = facetService;
        this.toggleMenu = new EventEmitter();
        this.valueChanged = new EventEmitter();
        this.facetContracted = true;
        this.combiner = XpoFacetFilterCombiner.AND;
        this.controlSubscriptions = [];
    }
    ngOnInit() {
        if (!this.facetId) {
            this.facetId = getUniqueFilterId();
        }
    }
    get filterCriteria() {
        return this.facetService.getFilterCriteria();
    }
    ngAfterContentInit() {
        this.filterSections.forEach((section) => {
            const subscription = section.valueChanged.subscribe((event) => {
                const param = event.controlCriteria;
                this.facetService.updateFilterCriteria(param);
                this.valueChanged.emit({
                    combiner: this.combiner,
                    filterCriteria: this.facetService.getFilterCriteria(),
                });
            });
            this.controlSubscriptions.push(subscription);
            section.configComponent();
        });
    }
    ngOnDestroy() {
        if (this.controlSubscriptions.length) {
            this.controlSubscriptions.forEach((item) => item.unsubscribe());
        }
    }
    toggleMenuFacet(event, onlyExpand = false) {
        if (onlyExpand && !this.facetContracted) {
            return;
        }
        this.facetContracted = !this.facetContracted;
        this.toggleMenu.emit({ open: !this.facetContracted });
        event.stopPropagation();
    }
}
XpoFacetFilterComponent.ɵfac = function XpoFacetFilterComponent_Factory(t) { return new (t || XpoFacetFilterComponent)(i0.ɵɵdirectiveInject(XpoFacetFilterService)); };
XpoFacetFilterComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoFacetFilterComponent, selectors: [["xpo-facet-filter"]], contentQueries: function XpoFacetFilterComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        i0.ɵɵcontentQuery(dirIndex, XpoFacetFilterSection, 4);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.filterSections = _t);
    } }, inputs: { facetContracted: "facetContracted", facetId: "facetId", combiner: "combiner" }, outputs: { toggleMenu: "toggleMenu", valueChanged: "valueChanged" }, features: [i0.ɵɵProvidersFeature([XpoFacetFilterService])], ngContentSelectors: _c1$3, decls: 6, vars: 10, consts: [[1, "xpo-FacetFilter-menu", 3, "ngClass", "click"], [1, "xpo-FacetFilter-menuTitle"], [1, "xpo-FacetFilter-menuAction", 3, "iconName", "click"], [1, "xpo-FacetFilter-menuLabel"], ["class", "xpo-FacetFilter-menuContainer", 4, "ngIf"], [1, "xpo-FacetFilter-menuContainer"]], template: function XpoFacetFilterComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵlistener("click", function XpoFacetFilterComponent_Template_div_click_0_listener($event) { return ctx.toggleMenuFacet($event, true); });
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "xpo-icon", 2);
        i0.ɵɵlistener("click", function XpoFacetFilterComponent_Template_xpo_icon_click_2_listener($event) { return ctx.toggleMenuFacet($event, false); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "span", 3);
        i0.ɵɵtext(4, " REFINE RESULTS ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(5, XpoFacetFilterComponent_div_5_Template, 2, 0, "div", 4);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(7, _c0$5, !ctx.facetContracted, ctx.facetContracted));
        i0.ɵɵadvance(2);
        i0.ɵɵclassProp("xpo-FacetFilter-menuAction--contracted", ctx.facetContracted);
        i0.ɵɵproperty("iconName", ctx.facetContracted ? "arrow-from-left" : "arrow-from-right");
        i0.ɵɵadvance(1);
        i0.ɵɵclassProp("xpo-FacetFilter-menuLabel--across", ctx.facetContracted);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", !ctx.facetContracted);
    } }, directives: [i2.NgClass, i3.XpoIcon, i2.NgIf], styles: [".flex--stretch[_ngcontent-%COMP%]{flex:1}.xpo-FacetFilter-menu[_ngcontent-%COMP%]{background-color:#fafafa;position:relative;height:100%;transition:.5s;border:1px solid #d8d8d8}.xpo-FacetFilter-menu--expanded[_ngcontent-%COMP%]{width:300px;background-color:#fff;transition:0s}.xpo-FacetFilter-menu--contracted[_ngcontent-%COMP%]{width:32px;transition:.5s;cursor:pointer}.xpo-FacetFilter-menuTitle[_ngcontent-%COMP%]{height:42px}.xpo-FacetFilter-menuAction[_ngcontent-%COMP%]{position:absolute;top:16px;right:8px;cursor:pointer;height:18px;width:18px;color:#4a4a4a}.xpo-FacetFilter-menuAction[_ngcontent-%COMP%]:hover{color:#212121}.xpo-FacetFilter-menuAction--contracted[_ngcontent-%COMP%]{right:8px}.xpo-FacetFilter-menuLabel[_ngcontent-%COMP%]{color:#6f6f6f;text-transform:uppercase;font-size:1rem;font-weight:400;position:absolute;top:16px;left:12px}.xpo-FacetFilter-menuLabel--across[_ngcontent-%COMP%]{position:absolute;top:80px;left:-33px;font-size:.875rem;transform:rotate(90deg);width:max-content}.xpo-FacetFilter-menuContainer[_ngcontent-%COMP%]{overflow-y:auto;height:calc(100% - 42px);padding:8px 12px 0}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoFacetFilterComponent, [{
        type: Component,
        args: [{
                selector: 'xpo-facet-filter',
                templateUrl: './filter-base.component.html',
                styleUrls: ['./filter-base.component.scss'],
                providers: [XpoFacetFilterService],
            }]
    }], function () { return [{ type: XpoFacetFilterService }]; }, { filterSections: [{
            type: ContentChildren,
            args: [XpoFacetFilterSection]
        }], toggleMenu: [{
            type: Output
        }], valueChanged: [{
            type: Output
        }], facetContracted: [{
            type: Input
        }], facetId: [{
            type: Input
        }], combiner: [{
            type: Input
        }] }); })();

const _c0$4 = ["*"];
class XpoFacetFilterEnumOptionComponent {
    constructor() {
        this.countItem = undefined;
        this.selectionChanged = new EventEmitter();
    }
    get countItems() {
        return this.countItem !== undefined ? `(${this.countItem})` : '';
    }
    ngOnInit() {
        this.label = getUniqueFilterId(5); // to identify unique controls from app side, as these re projected do not have a unique identifier
    }
    onSelectionChanged(matCheckBox) {
        this.selectionChanged.emit({ id: matCheckBox.source.id, selected: matCheckBox.source.checked });
    }
}
XpoFacetFilterEnumOptionComponent.ɵfac = function XpoFacetFilterEnumOptionComponent_Factory(t) { return new (t || XpoFacetFilterEnumOptionComponent)(); };
XpoFacetFilterEnumOptionComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoFacetFilterEnumOptionComponent, selectors: [["xpo-enum-option-facet-filter"]], hostAttrs: [1, "xpo-enum-option-facet-filter"], inputs: { value: "value" }, outputs: { selectionChanged: "selectionChanged" }, ngContentSelectors: _c0$4, decls: 3, vars: 3, consts: [[1, "xpo-FacetFilterEnum-checkbox", 3, "id", "ngModel", "ngModelChange", "change"]], template: function XpoFacetFilterEnumOptionComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "mat-checkbox", 0);
        i0.ɵɵlistener("ngModelChange", function XpoFacetFilterEnumOptionComponent_Template_mat_checkbox_ngModelChange_0_listener($event) { return ctx.isSelected = $event; })("change", function XpoFacetFilterEnumOptionComponent_Template_mat_checkbox_change_0_listener($event) { return ctx.onSelectionChanged($event); });
        i0.ɵɵprojection(1);
        i0.ɵɵtext(2);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("id", ctx.value)("ngModel", ctx.isSelected);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" ", ctx.countItems, "\n");
    } }, directives: [i3$1.MatCheckbox, i1.NgControlStatus, i1.NgModel], styles: [".mat-checkbox-label{display:contents}.mat-checkbox{margin:0;padding:0}.xpo-enum-option-facet-filter{display:block}\n"], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoFacetFilterEnumOptionComponent, [{
        type: Component,
        args: [{
                selector: 'xpo-enum-option-facet-filter',
                templateUrl: './custom-options.component.html',
                styleUrls: ['./custom-options.component.scss'],
                encapsulation: ViewEncapsulation.None,
                host: { class: 'xpo-enum-option-facet-filter' }
            }]
    }], null, { value: [{
            type: Input
        }], selectionChanged: [{
            type: Output
        }] }); })();

var XpoFacetFilterTypeControls;
(function (XpoFacetFilterTypeControls) {
    XpoFacetFilterTypeControls["Enum"] = "enum";
    XpoFacetFilterTypeControls["Option"] = "option";
    XpoFacetFilterTypeControls["RangeMinMax"] = "rangeMinMax";
    XpoFacetFilterTypeControls["QuickSearch"] = "quickSearch";
    XpoFacetFilterTypeControls["DateRange"] = "dateRange";
    XpoFacetFilterTypeControls["TimeRange"] = "timeRange";
})(XpoFacetFilterTypeControls || (XpoFacetFilterTypeControls = {}));

class XpoFacetRangeValidators {
    static validateRange(from, to) {
        const res = (formGroup) => {
            const controlFrom = formGroup.controls[from];
            const controlTo = formGroup.controls[to];
            controlTo.setErrors((controlTo === null || controlTo === void 0 ? void 0 : controlTo.value) && (controlFrom === null || controlFrom === void 0 ? void 0 : controlFrom.value) > (controlTo === null || controlTo === void 0 ? void 0 : controlTo.value) ? { invalidRange: true } : null);
        };
        return res;
    }
}

class XpoRangeComparatorDirective {
    constructor() { }
    validate(formGroup) {
        if (!this.rangeValidation || (Array.isArray(this.rangeValidation) && this.rangeValidation.length < 2)) {
            return null;
        }
        const minValue = this.rangeValidation[0];
        const maxValue = this.rangeValidation[1];
        if (!formGroup.controls[maxValue]) {
            return null;
        }
        return XpoFacetRangeValidators.validateRange(minValue, maxValue)(formGroup);
    }
    registerOnValidatorChange(_fn) {
    }
}
XpoRangeComparatorDirective.ɵfac = function XpoRangeComparatorDirective_Factory(t) { return new (t || XpoRangeComparatorDirective)(); };
XpoRangeComparatorDirective.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: XpoRangeComparatorDirective, selectors: [["", "rangeValidation", ""]], inputs: { rangeValidation: "rangeValidation" }, features: [i0.ɵɵProvidersFeature([
            { provide: NG_VALIDATORS, useExisting: XpoRangeComparatorDirective, multi: true }
        ])] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoRangeComparatorDirective, [{
        type: Directive,
        args: [{
                selector: '[rangeValidation]',
                providers: [
                    { provide: NG_VALIDATORS, useExisting: XpoRangeComparatorDirective, multi: true }
                ]
            }]
    }], function () { return []; }, { rangeValidation: [{
            type: Input,
            args: ['rangeValidation']
        }] }); })();

class XpoFacetFilerErrorComponent {
    constructor() {
        this.errorMessage = '';
    }
}
XpoFacetFilerErrorComponent.ɵfac = function XpoFacetFilerErrorComponent_Factory(t) { return new (t || XpoFacetFilerErrorComponent)(); };
XpoFacetFilerErrorComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoFacetFilerErrorComponent, selectors: [["app-error-facet"]], inputs: { errorMessage: "errorMessage" }, decls: 3, vars: 1, consts: [[1, "xpo-FacetControlError"], ["iconName", "error"]], template: function XpoFacetFilerErrorComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "span", 0);
        i0.ɵɵelement(1, "xpo-icon", 1);
        i0.ɵɵtext(2);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" ", ctx.errorMessage, "\n");
    } }, directives: [i3.XpoIcon], styles: [".flex--stretch[_ngcontent-%COMP%]{flex:1}.xpo-FacetControlError[_ngcontent-%COMP%]{display:flex;margin-top:8px;color:#d32f2f;font-weight:400;font-size:1rem}.xpo-FacetControlError[_ngcontent-%COMP%]   xpo-icon[_ngcontent-%COMP%]{margin-top:4px;margin-right:4px;width:1.143rem;height:1.143rem}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoFacetFilerErrorComponent, [{
        type: Component,
        args: [{
                selector: 'app-error-facet',
                templateUrl: './error.component.html',
                styleUrls: ['./error.component.scss'],
            }]
    }], null, { errorMessage: [{
            type: Input
        }] }); })();

const _c0$3 = ["rangeDateForm"];
function XpoFacetFilterDateRangeControlComponent_app_error_facet_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "app-error-facet", 13);
} }
const _c1$2 = function () { return ["minValue", "maxValue"]; };
const PREDEFINED_FORMAT_DATE = 'yyyy/MM/dd'; // universal format date  for filtering purposes
class XpoFacetFilterDateRangeControlComponent extends XpoFilterControlBaseComponent {
    constructor() {
        super();
        this.typeControl = XpoFacetFilterTypeControls.DateRange;
        this.filterModel = {};
        this.allowInferDataFromSource = false;
    }
    ngOnInit() {
        super.checkInit();
        this.originalFilterModel = cloneDeep(this.filterModel);
    }
    setModel(model) {
        if (Array.isArray(model) && model.length && typeof (model[0]) === 'string') {
            model = this.processEntryModel(model);
        }
        this.filterModel = cloneDeep(model);
        this.originalFilterModel = cloneDeep(this.filterModel);
    }
    processEntryModel(model) {
        model = model.filter(element => !!element).sort();
        return model.length ? {
            minValue: isDate(model[0]) ? new Date(model[0]) : undefined,
            maxValue: isDate(model[model.length - 1]) ? new Date(model[model.length - 1]) : undefined,
        } : undefined;
    }
    applyFilter() {
        var _a, _b, _c, _d;
        if (!((_b = (_a = this.rangeDateForm) === null || _a === void 0 ? void 0 : _a.form) === null || _b === void 0 ? void 0 : _b.pristine) && !((_d = (_c = this.rangeDateForm) === null || _c === void 0 ? void 0 : _c.form) === null || _d === void 0 ? void 0 : _d.valid)) {
            return;
        }
        this.onValueChanged(this.filterModel, this.mapFacetFilterControlToCriteria(cloneDeep(this.filterModel)));
    }
    onReset() {
        var _a, _b;
        this.filterModel = cloneDeep(this.originalFilterModel);
        (_b = (_a = this.rangeDateForm) === null || _a === void 0 ? void 0 : _a.form) === null || _b === void 0 ? void 0 : _b.markAsPristine();
        this.applyFilter();
    }
    mapFacetFilterControlToCriteria(val) {
        let operator = XpoFacetFilterDateOperators.BETWEEN;
        if (val.minValue === undefined) {
            operator = XpoFacetFilterDateOperators.LESSERTHAN;
            val.minValue = val.maxValue;
            val.maxValue = undefined;
        }
        else if (val.maxValue === undefined) {
            operator = XpoFacetFilterDateOperators.GREATERTHAN;
        }
        return {
            filterId: this.filterId,
            type: XpoFacetFilterTypeOperator.Date,
            conditions: [{
                    operator,
                    value: formatDate(val.minValue, PREDEFINED_FORMAT_DATE),
                    valueTo: formatDate(val.maxValue, PREDEFINED_FORMAT_DATE)
                }],
            invalid: !this.isValidCondition(),
        };
    }
    isValidCondition() {
        return (this.filterModel.maxValue !== undefined || this.filterModel.minValue !== undefined);
    }
}
XpoFacetFilterDateRangeControlComponent.ɵfac = function XpoFacetFilterDateRangeControlComponent_Factory(t) { return new (t || XpoFacetFilterDateRangeControlComponent)(); };
XpoFacetFilterDateRangeControlComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoFacetFilterDateRangeControlComponent, selectors: [["xpo-date-range-facet-filter"]], viewQuery: function XpoFacetFilterDateRangeControlComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$3, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.rangeDateForm = _t.first);
    } }, inputs: { filterModel: "filterModel" }, features: [i0.ɵɵProvidersFeature([
            { provide: XpoFilterControlBaseComponent, useExisting: forwardRef(() => XpoFacetFilterDateRangeControlComponent) },
        ]), i0.ɵɵInheritDefinitionFeature], decls: 18, vars: 11, consts: [[1, "xpo-FacetFilterRangeDate"], [3, "rangeValidation"], ["rangeDateForm", "ngForm"], ["floatLabel", "never", "xpoDatePicker", ""], ["matInput", "", "name", "minValue", "readonly", "true", 3, "ngModel", "matDatepicker", "ngModelChange"], ["minValue", "ngModel"], ["matSuffix", "", 3, "for"], ["matDatepickerToggleIcon", "", "iconName", "calendar"], ["datePickerInput", ""], ["matInput", "", "name", "maxValue", "readonly", "true", 3, "ngModel", "matDatepicker", "ngModelChange"], ["maxValue", "ngModel"], ["datePickerInput2", ""], ["errorMessage", "Invalid Range", 4, "ngIf"], ["errorMessage", "Invalid Range"]], template: function XpoFacetFilterDateRangeControlComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "form", 1, 2);
        i0.ɵɵelementStart(3, "mat-form-field", 3);
        i0.ɵɵelementStart(4, "input", 4, 5);
        i0.ɵɵlistener("ngModelChange", function XpoFacetFilterDateRangeControlComponent_Template_input_ngModelChange_4_listener($event) { return ctx.filterModel.minValue = $event; })("ngModelChange", function XpoFacetFilterDateRangeControlComponent_Template_input_ngModelChange_4_listener() { return ctx.applyFilter(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "mat-datepicker-toggle", 6);
        i0.ɵɵelement(7, "xpo-icon", 7);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(8, "mat-datepicker", null, 8);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(10, "mat-form-field", 3);
        i0.ɵɵelementStart(11, "input", 9, 10);
        i0.ɵɵlistener("ngModelChange", function XpoFacetFilterDateRangeControlComponent_Template_input_ngModelChange_11_listener($event) { return ctx.filterModel.maxValue = $event; })("ngModelChange", function XpoFacetFilterDateRangeControlComponent_Template_input_ngModelChange_11_listener() { return ctx.applyFilter(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(13, "mat-datepicker-toggle", 6);
        i0.ɵɵelement(14, "xpo-icon", 7);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(15, "mat-datepicker", null, 11);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(17, XpoFacetFilterDateRangeControlComponent_app_error_facet_17_Template, 1, 0, "app-error-facet", 12);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r2 = i0.ɵɵreference(9);
        const _r3 = i0.ɵɵreference(12);
        const _r4 = i0.ɵɵreference(16);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("rangeValidation", i0.ɵɵpureFunction0(10, _c1$2));
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngModel", ctx.filterModel.minValue)("matDatepicker", _r2);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("for", _r2);
        i0.ɵɵadvance(5);
        i0.ɵɵclassProp("inputError", _r3.errors == null ? null : _r3.errors.invalidRange);
        i0.ɵɵproperty("ngModel", ctx.filterModel.maxValue)("matDatepicker", _r4);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("for", _r4);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", _r3.errors == null ? null : _r3.errors.invalidRange);
    } }, directives: [i1.ɵNgNoValidate, i1.NgControlStatusGroup, i1.NgForm, XpoRangeComparatorDirective, i3$2.MatFormField, i4.XpoDatePickerDirective, i5.MatInput, i1.DefaultValueAccessor, i6.MatDatepickerInput, i1.NgControlStatus, i1.NgModel, i6.MatDatepickerToggle, i3$2.MatSuffix, i3.XpoIcon, i6.MatDatepickerToggleIcon, i6.MatDatepicker, i2.NgIf, XpoFacetFilerErrorComponent], styles: [".xpo-FacetFilterRangeDate .mat-form-field{margin:0 12px 0 0;width:110px}.xpo-FacetFilterRangeDate .mat-form-field.xpo-DatePicker.mat-form-field-hide-placeholder .mat-form-field-label{font-size:12px;top:47%}.xpo-FacetFilterRangeDate .mat-form-field.mat-form-field-type-mat-input .mat-form-field-flex{height:30px}.xpo-FacetFilterRangeDate .mat-form-field.mat-form-field-type-mat-input .mat-form-field-flex .mat-form-field-infix .mat-input-element{padding:6px}.xpo-FacetFilterRangeDate .mat-form-field.mat-form-field-type-mat-input .mat-form-field-flex .mat-form-field-suffix .mat-icon{margin-top:1px}.xpo-FacetFilterRangeDate .xpo-DatePicker .mat-form-field-wrapper .mat-form-field-flex .mat-form-field-infix{min-width:0}.xpo-FacetFilterRangeDate>form .xpo-FacetControlError{margin-top:0}\n"], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoFacetFilterDateRangeControlComponent, [{
        type: Component,
        args: [{
                selector: 'xpo-date-range-facet-filter',
                templateUrl: './filter-control-date-range.component.html',
                styleUrls: ['./filter-control-date-range.component.scss'],
                encapsulation: ViewEncapsulation.None,
                providers: [
                    { provide: XpoFilterControlBaseComponent, useExisting: forwardRef(() => XpoFacetFilterDateRangeControlComponent) },
                ],
            }]
    }], function () { return []; }, { rangeDateForm: [{
            type: ViewChild,
            args: ['rangeDateForm']
        }], filterModel: [{
            type: Input
        }] }); })();

var XpoFacetEnumFilterTexts;
(function (XpoFacetEnumFilterTexts) {
    XpoFacetEnumFilterTexts["ShowAll"] = "Show all items";
    XpoFacetEnumFilterTexts["ShowLess"] = "Show less items";
})(XpoFacetEnumFilterTexts || (XpoFacetEnumFilterTexts = {}));
;

function XpoFacetFilterEnumShowMoreDialogComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵelementStart(1, "mat-checkbox", 9);
    i0.ɵɵlistener("ngModelChange", function XpoFacetFilterEnumShowMoreDialogComponent_div_7_Template_mat_checkbox_ngModelChange_1_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r3); const item_r1 = restoredCtx.$implicit; return item_r1.selected = $event; })("ngModelChange", function XpoFacetFilterEnumShowMoreDialogComponent_div_7_Template_mat_checkbox_ngModelChange_1_listener() { i0.ɵɵrestoreView(_r3); const ctx_r4 = i0.ɵɵnextContext(); return ctx_r4.onChangeSelected(); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r1 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngModel", item_r1.selected);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", item_r1.label, " ");
} }
class XpoFacetFilterEnumShowMoreDialogComponent {
    constructor(dialogRef, data) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.listItems = [];
        this.allSelected = false;
    }
    ngOnInit() {
        this.listItems = this.data.listItems;
        this.title = this.data.dialogTitle;
        this.onChangeSelected();
    }
    closeDialog(listItems) {
        this.dialogRef.close(listItems);
    }
    listItemsTracker(item) {
        var _a;
        return (_a = item.value) === null || _a === void 0 ? void 0 : _a.toString();
    }
    onChangeSelected() {
        this.allSelected = this.listItems.length && this.listItems.every((item) => item.selected);
    }
    someSelected() {
        return this.listItems.some((item) => item.selected) && !this.allSelected;
    }
    setAll(selected) {
        this.allSelected = selected;
        this.listItems.forEach((item) => (item.selected = selected));
    }
}
XpoFacetFilterEnumShowMoreDialogComponent.ɵfac = function XpoFacetFilterEnumShowMoreDialogComponent_Factory(t) { return new (t || XpoFacetFilterEnumShowMoreDialogComponent)(i0.ɵɵdirectiveInject(i1$1.MatDialogRef), i0.ɵɵdirectiveInject(MAT_DIALOG_DATA)); };
XpoFacetFilterEnumShowMoreDialogComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoFacetFilterEnumShowMoreDialogComponent, selectors: [["xpo-enum-facet-filter"]], decls: 14, vars: 5, consts: [["mat-dialog-title", ""], ["mat-dialog-content", "", 1, "xpo-FacetFilterDialogEnum"], [1, "xpo-FacetFilterDialogEnum-checkboxAll", 3, "checked", "indeterminate", "change"], [1, "xpo-FacetFilterDialogEnum-container"], ["class", "xpo-FacetFilterDialogEnum-containerCheckbox", 4, "ngFor", "ngForOf", "ngForTrackBy"], ["mat-dialog-actions", "", 1, "xpo-FacetFilterDialogEnum-actions"], ["mat-flat-button", "", 3, "click"], ["mat-stroked-button", "", 3, "click"], [1, "xpo-FacetFilterDialogEnum-containerCheckbox"], [3, "ngModel", "ngModelChange"]], template: function XpoFacetFilterEnumShowMoreDialogComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "h1", 0);
        i0.ɵɵtext(1);
        i0.ɵɵelement(2, "xpo-dialog-close-button");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "div", 1);
        i0.ɵɵelementStart(4, "mat-checkbox", 2);
        i0.ɵɵlistener("change", function XpoFacetFilterEnumShowMoreDialogComponent_Template_mat_checkbox_change_4_listener($event) { return ctx.setAll($event.checked); });
        i0.ɵɵtext(5, " All\n");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "div", 3);
        i0.ɵɵtemplate(7, XpoFacetFilterEnumShowMoreDialogComponent_div_7_Template, 3, 2, "div", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "div", 5);
        i0.ɵɵelementStart(9, "xpo-button-group");
        i0.ɵɵelementStart(10, "button", 6);
        i0.ɵɵlistener("click", function XpoFacetFilterEnumShowMoreDialogComponent_Template_button_click_10_listener() { return ctx.closeDialog(ctx.listItems); });
        i0.ɵɵtext(11, "Apply");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(12, "button", 7);
        i0.ɵɵlistener("click", function XpoFacetFilterEnumShowMoreDialogComponent_Template_button_click_12_listener() { return ctx.closeDialog(); });
        i0.ɵɵtext(13, "Cancel");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", ctx.title, " ");
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("checked", ctx.allSelected)("indeterminate", ctx.someSelected());
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngForOf", ctx.listItems)("ngForTrackBy", ctx.listItemsTracker);
    } }, directives: [i1$1.MatDialogTitle, i2$1.XpoDialogCloseButtonComponent, i1$1.MatDialogContent, i3$1.MatCheckbox, i2.NgForOf, i1$1.MatDialogActions, i5$1.XpoButtonGroup, i6$1.MatButton, i1.NgControlStatus, i1.NgModel], styles: [".flex--stretch[_ngcontent-%COMP%]{flex:1}.xpo-FacetFilterDialogEnum-checkboxAll[_ngcontent-%COMP%]{display:block}.xpo-FacetFilterDialogEnum-container[_ngcontent-%COMP%]{overflow-y:auto;display:flex;flex-wrap:wrap}.xpo-FacetFilterDialogEnum-containerCheckbox[_ngcontent-%COMP%]{width:20%}.xpo-FacetFilterDialogEnum-actions[_ngcontent-%COMP%]{justify-content:flex-start!important}.xpo-FacetFilterDialogEnum-actions[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{margin-left:8px}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoFacetFilterEnumShowMoreDialogComponent, [{
        type: Component,
        args: [{
                selector: 'xpo-enum-facet-filter',
                templateUrl: './show-more-modal.component.html',
                styleUrls: ['./show-more-modal.component.scss'],
            }]
    }], function () { return [{ type: i1$1.MatDialogRef }, { type: undefined, decorators: [{
                type: Inject,
                args: [MAT_DIALOG_DATA]
            }] }]; }, null); })();

function XpoFacetFilterEnumControlComponent_mat_checkbox_0_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-checkbox", 2);
    i0.ɵɵlistener("change", function XpoFacetFilterEnumControlComponent_mat_checkbox_0_Template_mat_checkbox_change_0_listener($event) { i0.ɵɵrestoreView(_r3); const ctx_r2 = i0.ɵɵnextContext(); return ctx_r2.setAll($event.checked); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("checked", ctx_r0.allSelected)("indeterminate", ctx_r0.someSelected);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" All ", ctx_r0.getTotalCountItems, "\n");
} }
function XpoFacetFilterEnumControlComponent_ng_container_1_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "mat-checkbox", 7);
    i0.ɵɵlistener("ngModelChange", function XpoFacetFilterEnumControlComponent_ng_container_1_div_2_Template_mat_checkbox_ngModelChange_1_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r8); const item_r6 = restoredCtx.$implicit; return item_r6.selected = $event; })("ngModelChange", function XpoFacetFilterEnumControlComponent_ng_container_1_div_2_Template_mat_checkbox_ngModelChange_1_listener() { i0.ɵɵrestoreView(_r8); const ctx_r9 = i0.ɵɵnextContext(2); return ctx_r9.onChangeSelected(); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r6 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngModel", item_r6.selected);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", item_r6.label, " ");
} }
function XpoFacetFilterEnumControlComponent_ng_container_1_span_4_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 8);
    i0.ɵɵlistener("click", function XpoFacetFilterEnumControlComponent_ng_container_1_span_4_Template_span_click_0_listener() { i0.ɵɵrestoreView(_r11); const ctx_r10 = i0.ɵɵnextContext(2); return ctx_r10.onShowMoreItems(); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r5.showAllText, " ");
} }
function XpoFacetFilterEnumControlComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 3);
    i0.ɵɵtemplate(2, XpoFacetFilterEnumControlComponent_ng_container_1_div_2_Template, 3, 2, "div", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 5);
    i0.ɵɵtemplate(4, XpoFacetFilterEnumControlComponent_ng_container_1_span_4_Template, 2, 1, "span", 6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r1.itemsToShow)("ngForTrackBy", ctx_r1.filterModelTracker);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.showMoreItemsActionButton);
} }
const _c0$2 = ["*"];
const DEFAULT_MAX_ITEMS = 5;
const DEFAULT_WIDTH_MODAL = '50%';
class XpoFacetFilterEnumControlComponent extends XpoFilterControlBaseComponent {
    constructor(cdr, dialog) {
        super();
        this.cdr = cdr;
        this.dialog = dialog;
        this.numOfItemsToShow = DEFAULT_MAX_ITEMS;
        this.showAllText = XpoFacetEnumFilterTexts.ShowAll;
        this.showLessText = XpoFacetEnumFilterTexts.ShowLess;
        this.allSelected = false;
        this.showMoreItems = false;
        this.projectedOptions = false;
        this.filterModel = [];
        this.sort = undefined;
        this.showCountItems = false;
        this.originalFilterModel = [];
        this.typeControl = XpoFacetFilterTypeControls.Enum;
        this.totalCountItems = 0;
        this.controlSubscriptions = [];
        this.controlState = [];
    }
    get getTotalCountItems() {
        return this.showCountItems ? `(${this.totalCountItems.toString()})` : undefined;
    }
    get optionValues() {
        return this.optionItems.toArray().map(el => el.label);
    }
    ngAfterContentChecked() {
        this.setOptionsEvents();
    }
    get itemsToShow() {
        return this.showMoreItems ? this.filterModel : this.filterModel.slice(0, this.numOfItemsToShow);
    }
    get showMoreItemsActionButton() {
        return this.filterModel.length > this.numOfItemsToShow;
    }
    get someSelected() {
        return this.filterModel.some((item) => item.selected) && !this.allSelected;
    }
    ngOnInit() {
        var _a;
        (_a = this.filterModel) === null || _a === void 0 ? void 0 : _a.sort((current, next) => sortItems(this.sort, current.label, next.label));
        this.originalFilterModel = cloneDeep(this.filterModel);
        super.checkInit();
    }
    ngAfterContentInit() {
        this.setOptionsEvents();
        this.allowInferDataFromSource = this.projectedOptions ? false : this.allowInferDataFromSource;
    }
    ngOnDestroy() {
        this.controlSubscriptions.forEach(subscription => subscription.unsubscribe());
    }
    setModel(model) {
        var _a;
        if (Array.isArray(model) && model.length && typeof (model[0]) === 'string') {
            model = this.showCountItems ? this.processEntryModelWithCount(model) : this.processEntryModel(model);
            if (this.optionItems.length) {
                // lets add the missing elements in custom filterModel array in case that inferred data do not have them
                const mergeModel = [...model, ...this.filterModel.filter(item => !model.some(mod => mod === item.value))];
                model = mergeModel;
            }
        }
        this.filterModel = model;
        (_a = this.filterModel) === null || _a === void 0 ? void 0 : _a.sort((current, next) => sortItems(this.sort, current.label, next.label));
        this.originalFilterModel = cloneDeep(this.filterModel);
        this.cdr.markForCheck();
    }
    processEntryModelWithCount(model) {
        const enumList = model.reduce((obj, item) => {
            const key = item || '';
            obj[key] = (obj[key] || 0) + 1;
            return obj;
        }, {});
        this.totalCountItems = 0;
        return Object.keys(enumList).map((key) => {
            var _a;
            this.totalCountItems += enumList[key];
            if (((_a = this.optionItems) === null || _a === void 0 ? void 0 : _a.length) && this.showCountItems) {
                this.optionItems.find((option) => option.value === key).countItem = enumList[key];
            }
            return {
                label: this.showCountItems ? `${key} (${enumList[key]})` : key,
                value: key,
                count: enumList[key],
            };
        });
    }
    setOptionsEvents() {
        // const diffOptions = this.optionValues
        //   .some((option) => this.controlState.some((value) => value !== option));
        var _a, _b;
        const diffOptions = JSON.stringify((_a = this.optionValues) !== null && _a !== void 0 ? _a : []) !== JSON.stringify((_b = this.controlState) !== null && _b !== void 0 ? _b : []);
        if (this.optionItems && this.optionItems.length && diffOptions) {
            this.controlState = this.optionValues;
            this.controlSubscriptions.forEach((subscription) => subscription.unsubscribe());
            this.filterModel = [];
            this.projectedOptions = this.optionItems.length > 0;
            const items = [];
            this.optionItems.forEach((option) => {
                items.push({ label: '', value: option.value, selected: false });
                const subscription = option.selectionChanged.subscribe((event) => {
                    if (this.filterModel) {
                        this.filterModel.find((item) => item.value === event.id).selected = event.selected;
                        this.onChangeSelected();
                    }
                });
                this.controlSubscriptions.push(subscription);
            });
            this.onChangeSelected(); // lets clear all options if new items are projected
            this.setModel(items);
        }
    }
    processEntryModel(model) {
        return Array.from(new Set(model)).map(item => ({
            label: item,
            value: item || '',
        }));
    }
    onChangeSelected() {
        this.allSelected = this.filterModel.length && this.filterModel.every((item) => item.selected);
        this.applyFilter();
        this.cdr.markForCheck();
    }
    setAll(selected) {
        this.allSelected = selected;
        this.filterModel.forEach((item) => (item.selected = selected));
        this.optionItems.forEach((option) => option.isSelected = selected);
        this.applyFilter();
    }
    onReset() {
        this.filterModel = cloneDeep(this.originalFilterModel);
        this.optionItems.forEach((option) => option.isSelected = false);
        this.allSelected = false;
        this.applyFilter();
        this.showMoreItems = false;
        this.cdr.markForCheck();
    }
    onShowMoreItems() {
        const dialogRef = this.dialog.open(XpoFacetFilterEnumShowMoreDialogComponent, Object.assign(Object.assign({ width: DEFAULT_WIDTH_MODAL }, this.dialogConfig), { data: { dialogTitle: this.parentSectionName, listItems: cloneDeep(this.filterModel) } }));
        const modalSubscription = dialogRef.afterClosed().subscribe((result) => {
            this.filterModel = result ? result : this.filterModel;
            this.onChangeSelected();
            this.cdr.markForCheck();
            modalSubscription.unsubscribe();
        });
    }
    filterModelTracker(itemModel) {
        var _a;
        return (_a = itemModel.value) === null || _a === void 0 ? void 0 : _a.toString();
    }
    applyFilter() {
        this.onValueChanged(this.filterModel, this.mapFacetFilterControlToCriteria(this.filterModel));
    }
    mapFacetFilterControlToCriteria(val) {
        var _a;
        return {
            filterId: this.filterId,
            type: XpoFacetFilterTypeOperator.String,
            conditions: (_a = val === null || val === void 0 ? void 0 : val.filter((el) => el === null || el === void 0 ? void 0 : el.selected)) === null || _a === void 0 ? void 0 : _a.map((values) => ({ operator: XpoFacetFilterStringOperators.EQUAL, value: values.value })),
            invalid: !this.isValidCondition(),
        };
    }
    isValidCondition() {
        return this.filterModel.some(item => (item.selected));
    }
}
XpoFacetFilterEnumControlComponent.ɵfac = function XpoFacetFilterEnumControlComponent_Factory(t) { return new (t || XpoFacetFilterEnumControlComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1$1.MatDialog)); };
XpoFacetFilterEnumControlComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoFacetFilterEnumControlComponent, selectors: [["xpo-enum-facet-filter"]], contentQueries: function XpoFacetFilterEnumControlComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        i0.ɵɵcontentQuery(dirIndex, XpoFacetFilterEnumOptionComponent, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.optionItems = _t);
    } }, inputs: { numOfItemsToShow: "numOfItemsToShow", showAllText: "showAllText", showLessText: "showLessText", filterModel: "filterModel", dialogConfig: "dialogConfig", sort: "sort", showCountItems: "showCountItems" }, features: [i0.ɵɵProvidersFeature([{ provide: XpoFilterControlBaseComponent, useExisting: forwardRef(() => XpoFacetFilterEnumControlComponent) }]), i0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c0$2, decls: 3, vars: 2, consts: [["class", "xpo-FacetFilterEnum-checkbox", 3, "checked", "indeterminate", "change", 4, "ngIf"], [4, "ngIf"], [1, "xpo-FacetFilterEnum-checkbox", 3, "checked", "indeterminate", "change"], [1, "xpo-FacetFilterEnum-container"], [4, "ngFor", "ngForOf", "ngForTrackBy"], [1, "xpo-FacetFilterEnum-remaining"], ["class", "xpo-FacetFilterEnum-showMore", 3, "click", 4, "ngIf"], [1, "xpo-FacetFilterEnum-checkbox", 3, "ngModel", "ngModelChange"], [1, "xpo-FacetFilterEnum-showMore", 3, "click"]], template: function XpoFacetFilterEnumControlComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵtemplate(0, XpoFacetFilterEnumControlComponent_mat_checkbox_0_Template, 2, 3, "mat-checkbox", 0);
        i0.ɵɵtemplate(1, XpoFacetFilterEnumControlComponent_ng_container_1_Template, 5, 3, "ng-container", 1);
        i0.ɵɵprojection(2);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.itemsToShow.length > 1);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.projectedOptions);
    } }, directives: [i2.NgIf, i3$1.MatCheckbox, i2.NgForOf, i1.NgControlStatus, i1.NgModel], styles: [".flex--stretch[_ngcontent-%COMP%]{flex:1}.xpo-FacetFilterEnum-checkbox[_ngcontent-%COMP%]{margin:0;padding:0}.xpo-FacetFilterEnum-container[_ngcontent-%COMP%]{padding-bottom:8px}.xpo-FacetFilterEnum-remaining[_ngcontent-%COMP%]{display:flex}.xpo-FacetFilterEnum-showMore[_ngcontent-%COMP%]{cursor:pointer;color:#1976d2;padding-top:3px}.xpo-FacetFilterEnum-showMore[_ngcontent-%COMP%]:hover{color:#0d47a1}.xpo-FacetFilterEnum-showMore-icon[_ngcontent-%COMP%]{margin-left:-3px}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoFacetFilterEnumControlComponent, [{
        type: Component,
        args: [{
                selector: 'xpo-enum-facet-filter',
                templateUrl: './filter-control-enum.component.html',
                styleUrls: ['./filter-control-enum.component.scss'],
                providers: [{ provide: XpoFilterControlBaseComponent, useExisting: forwardRef(() => XpoFacetFilterEnumControlComponent) }],
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i1$1.MatDialog }]; }, { optionItems: [{
            type: ContentChildren,
            args: [XpoFacetFilterEnumOptionComponent, { descendants: true }]
        }], numOfItemsToShow: [{
            type: Input
        }], showAllText: [{
            type: Input
        }], showLessText: [{
            type: Input
        }], filterModel: [{
            type: Input
        }], dialogConfig: [{
            type: Input
        }], sort: [{
            type: Input
        }], showCountItems: [{
            type: Input
        }] }); })();

function XpoFacetFilterOptionControlComponent_mat_radio_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-radio-button", 3);
    i0.ɵɵlistener("change", function XpoFacetFilterOptionControlComponent_mat_radio_button_2_Template_mat_radio_button_change_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r3); const item_r1 = restoredCtx.$implicit; const ctx_r2 = i0.ɵɵnextContext(); return ctx_r2.updateSelected(item_r1); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r1 = ctx.$implicit;
    i0.ɵɵproperty("value", item_r1)("checked", item_r1.selected);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", item_r1.label, " ");
} }
class XpoFacetFilterOptionControlComponent extends XpoFilterControlBaseComponent {
    constructor() {
        super();
        // To keep an original copy of the filterModel the user passed in.
        this.originalFilterModel = [];
        this.typeControl = XpoFacetFilterTypeControls.Option;
        this.filterModel = [];
        this.sort = undefined;
        this.showCountItems = false;
    }
    ngOnInit() {
        var _a;
        (_a = this.filterModel) === null || _a === void 0 ? void 0 : _a.sort((current, next) => sortItems(this.sort, current.label, next.label));
        this.originalFilterModel = cloneDeep(this.filterModel);
        super.checkInit();
    }
    /**
     * Method which allows setting model from external source
     * @param model
     */
    setModel(model) {
        var _a;
        if (Array.isArray(model) && model.length && typeof (model[0]) === 'string') {
            model = this.processEntryModel(model);
        }
        this.filterModel = model;
        (_a = this.filterModel) === null || _a === void 0 ? void 0 : _a.sort((current, next) => sortItems(this.sort, current.label, next.label));
        this.originalFilterModel = cloneDeep(this.filterModel);
    }
    processEntryModel(model) {
        const enumList = model.reduce((obj, item) => {
            const key = item || '';
            obj[key] = (obj[key] || 0) + 1;
            return obj;
        }, {});
        return Object.keys(enumList).map((key) => ({
            label: this.showCountItems ? `${(key)} (${enumList[key]})` : key,
            value: key,
            selected: false,
        }));
    }
    updateSelected(item) {
        this.clearSelections();
        item.selected = true;
        this.selectedItem = item;
        this.applyFilter();
    }
    applyFilter() {
        this.onValueChanged([this.selectedItem], this.mapFacetFilterControlToCriteria(this.selectedItem));
    }
    clearSelections() {
        this.filterModel.map((el) => (el.selected = false));
        this.selectedItem = null;
    }
    onReset() {
        this.filterModel = cloneDeep(this.originalFilterModel);
        this.selectedItem = null;
        this.applyFilter();
    }
    mapFacetFilterControlToCriteria(item) {
        return {
            filterId: this.filterId,
            type: XpoFacetFilterTypeOperator.String,
            conditions: [{ operator: XpoFacetFilterStringOperators.EQUAL, value: (item === null || item === void 0 ? void 0 : item.value) || null }],
            invalid: !this.isValidCondition(),
        };
    }
    isValidCondition() {
        return !!this.selectedItem;
    }
}
XpoFacetFilterOptionControlComponent.ɵfac = function XpoFacetFilterOptionControlComponent_Factory(t) { return new (t || XpoFacetFilterOptionControlComponent)(); };
XpoFacetFilterOptionControlComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoFacetFilterOptionControlComponent, selectors: [["xpo-option-facet-filter"]], inputs: { filterModel: "filterModel", sort: "sort", showCountItems: "showCountItems" }, features: [i0.ɵɵProvidersFeature([{ provide: XpoFilterControlBaseComponent, useExisting: forwardRef(() => XpoFacetFilterOptionControlComponent) }]), i0.ɵɵInheritDefinitionFeature], decls: 3, vars: 1, consts: [[1, "xpo-FacetFilterOption"], [1, "xpo-FacetFilterOption-group"], ["class", "xpo-FacetFilterOption-button", 3, "value", "checked", "change", 4, "ngFor", "ngForOf"], [1, "xpo-FacetFilterOption-button", 3, "value", "checked", "change"]], template: function XpoFacetFilterOptionControlComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "mat-radio-group", 1);
        i0.ɵɵtemplate(2, XpoFacetFilterOptionControlComponent_mat_radio_button_2_Template, 2, 3, "mat-radio-button", 2);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngForOf", ctx.filterModel);
    } }, directives: [i1$2.MatRadioGroup, i2.NgForOf, i1$2.MatRadioButton], styles: [".xpo-FacetFilterOption-group[_ngcontent-%COMP%]{display:flex;flex-direction:column}.xpo-FacetFilterOption-button[_ngcontent-%COMP%]{padding-bottom:5px;text-transform:capitalize}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoFacetFilterOptionControlComponent, [{
        type: Component,
        args: [{
                selector: 'xpo-option-facet-filter',
                templateUrl: './filter-control-option.component.html',
                styleUrls: ['./filter-control-option.component.scss'],
                providers: [{ provide: XpoFilterControlBaseComponent, useExisting: forwardRef(() => XpoFacetFilterOptionControlComponent) }],
            }]
    }], function () { return []; }, { filterModel: [{
            type: Input
        }], sort: [{
            type: Input
        }], showCountItems: [{
            type: Input
        }] }); })();

var XpoFacetRangeFilterTexts;
(function (XpoFacetRangeFilterTexts) {
    XpoFacetRangeFilterTexts["Under"] = "Under";
    XpoFacetRangeFilterTexts["Over"] = "Over";
})(XpoFacetRangeFilterTexts || (XpoFacetRangeFilterTexts = {}));
;

const _c0$1 = ["rangeNumberForm"];
function XpoFacetFilterRangeNumberControlComponent_div_1_li_2_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵelementStart(1, "span", 10);
    i0.ɵɵlistener("click", function XpoFacetFilterRangeNumberControlComponent_div_1_li_2_Template_span_click_1_listener() { const restoredCtx = i0.ɵɵrestoreView(_r9); const value_r6 = restoredCtx.$implicit; const ctx_r8 = i0.ɵɵnextContext(2); return ctx_r8.setFilterLink(value_r6); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r7 = ctx.index;
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r5.rangeLabelsLinks[i_r7], " ");
} }
function XpoFacetFilterRangeNumberControlComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "ul");
    i0.ɵɵtemplate(2, XpoFacetFilterRangeNumberControlComponent_div_1_li_2_Template, 3, 1, "li", 9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r0.filterModel);
} }
function XpoFacetFilterRangeNumberControlComponent_app_error_facet_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "app-error-facet", 11);
} }
const _c1$1 = function () { return ["minValue", "maxValue"]; };
class XpoFacetFilterRangeNumberControlComponent extends XpoFilterControlBaseComponent {
    constructor() {
        super();
        this.typeControl = XpoFacetFilterTypeControls.RangeMinMax;
        this.filterModel = {};
        this.rangeLabelsLinks = [];
    }
    get isArrayOfValues() {
        return Array.isArray(this.filterModel);
    }
    get originalRangeValues() {
        return this.isArrayOfValues ? { minValue: undefined, maxValue: undefined } : this.filterModel;
    }
    ngOnInit() {
        super.checkInit();
        this.originalFilterModel = cloneDeep(this.originalRangeValues);
        this.setRangeLabels();
    }
    setModel(model) {
        if (Array.isArray(model) && model.length) {
            model = this.processEntryModel(model);
        }
        this.filterModel = model;
        this.originalFilterModel = cloneDeep(this.filterModel);
    }
    processEntryModel(model) {
        const arrNumbers = model.map(element => +element).sort((a, b) => a - b);
        return model.length ? {
            minValue: arrNumbers[0],
            maxValue: arrNumbers[arrNumbers.length - 1],
        } : undefined;
    }
    applyFilter() {
        var _a, _b, _c, _d;
        if (!((_b = (_a = this.rangeNumberForm) === null || _a === void 0 ? void 0 : _a.form) === null || _b === void 0 ? void 0 : _b.pristine) && !((_d = (_c = this.rangeNumberForm) === null || _c === void 0 ? void 0 : _c.form) === null || _d === void 0 ? void 0 : _d.valid)) {
            return;
        }
        this.onValueChanged(this.originalFilterModel, this.mapFacetFilterControlToCriteria(cloneDeep(this.originalFilterModel)));
    }
    setFilterLink(value) {
        var _a, _b;
        this.originalFilterModel = cloneDeep(value);
        (_b = (_a = this.rangeNumberForm) === null || _a === void 0 ? void 0 : _a.form) === null || _b === void 0 ? void 0 : _b.markAsPristine();
        this.applyFilter();
    }
    validateKey($event) {
        if ($event.code === 'Enter') {
            this.applyFilter();
        }
    }
    onReset() {
        var _a, _b;
        this.originalFilterModel = cloneDeep(this.originalRangeValues);
        (_b = (_a = this.rangeNumberForm) === null || _a === void 0 ? void 0 : _a.form) === null || _b === void 0 ? void 0 : _b.markAsPristine();
        this.applyFilter();
    }
    mapFacetFilterControlToCriteria(val) {
        let operator = XpoFacetFilterNumberOperators.BETWEEN;
        if ((val.minValue === undefined || val.minValue === null) && isNumber(val.maxValue)) {
            operator = XpoFacetFilterNumberOperators.LESSERTHAN;
            val.minValue = val.maxValue;
            val.maxValue = undefined;
        }
        else if ((val.maxValue === undefined || val.maxValue === null) && isNumber(val.minValue)) {
            operator = XpoFacetFilterNumberOperators.GREATERTHAN;
        }
        return {
            filterId: this.filterId,
            type: XpoFacetFilterTypeOperator.Number,
            conditions: [{ operator, value: val.minValue, valueTo: val.maxValue }],
            invalid: !this.isValidCondition(),
        };
    }
    isValidCondition() {
        return (isNumber(this.originalFilterModel.maxValue) || isNumber(this.originalFilterModel.minValue));
    }
    setRangeLabels() {
        if (this.isArrayOfValues) {
            this.rangeLabelsLinks = this.filterModel.map((item) => {
                let labelTextFrom = item.minValue === undefined ? `${XpoFacetRangeFilterTexts.Under} ` : `${item.minValue.toString()} - `;
                if (item.maxValue === undefined) {
                    labelTextFrom = `${XpoFacetRangeFilterTexts.Over} `;
                }
                const labelTextTo = item.maxValue === undefined ? item.minValue.toString() : item.maxValue.toString();
                return labelTextFrom + labelTextTo;
            });
        }
    }
}
XpoFacetFilterRangeNumberControlComponent.ɵfac = function XpoFacetFilterRangeNumberControlComponent_Factory(t) { return new (t || XpoFacetFilterRangeNumberControlComponent)(); };
XpoFacetFilterRangeNumberControlComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoFacetFilterRangeNumberControlComponent, selectors: [["xpo-range-facet-filter"]], viewQuery: function XpoFacetFilterRangeNumberControlComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$1, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.rangeNumberForm = _t.first);
    } }, inputs: { filterModel: "filterModel" }, features: [i0.ɵɵProvidersFeature([{ provide: XpoFilterControlBaseComponent, useExisting: forwardRef(() => XpoFacetFilterRangeNumberControlComponent) }]), i0.ɵɵInheritDefinitionFeature], decls: 9, vars: 8, consts: [[1, "xpo-FacetFilterRange"], [4, "ngIf"], [3, "rangeValidation"], ["rangeNumberForm", "ngForm"], ["type", "number", "name", "minValue", "placeholder", "MIN", 1, "xpo-FacetFilterRange-input", 3, "ngModel", "ngModelChange", "blur", "keyup"], ["minValue", "ngModel"], ["type", "number", "name", "maxValue", "placeholder", "MAX", 1, "xpo-FacetFilterRange-input", 3, "ngModel", "ngModelChange", "blur", "keyup"], ["maxValue", "ngModel"], ["errorMessage", "Invalid Range", 4, "ngIf"], [4, "ngFor", "ngForOf"], [1, "xpo-FacetFilterRange-links", 3, "click"], ["errorMessage", "Invalid Range"]], template: function XpoFacetFilterRangeNumberControlComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, XpoFacetFilterRangeNumberControlComponent_div_1_Template, 3, 1, "div", 1);
        i0.ɵɵelementStart(2, "form", 2, 3);
        i0.ɵɵelementStart(4, "input", 4, 5);
        i0.ɵɵlistener("ngModelChange", function XpoFacetFilterRangeNumberControlComponent_Template_input_ngModelChange_4_listener($event) { return ctx.originalFilterModel.minValue = $event; })("blur", function XpoFacetFilterRangeNumberControlComponent_Template_input_blur_4_listener() { return ctx.applyFilter(); })("keyup", function XpoFacetFilterRangeNumberControlComponent_Template_input_keyup_4_listener($event) { return ctx.validateKey($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "input", 6, 7);
        i0.ɵɵlistener("ngModelChange", function XpoFacetFilterRangeNumberControlComponent_Template_input_ngModelChange_6_listener($event) { return ctx.originalFilterModel.maxValue = $event; })("blur", function XpoFacetFilterRangeNumberControlComponent_Template_input_blur_6_listener() { return ctx.applyFilter(); })("keyup", function XpoFacetFilterRangeNumberControlComponent_Template_input_keyup_6_listener($event) { return ctx.validateKey($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(8, XpoFacetFilterRangeNumberControlComponent_app_error_facet_8_Template, 1, 0, "app-error-facet", 8);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r3 = i0.ɵɵreference(7);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isArrayOfValues);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("rangeValidation", i0.ɵɵpureFunction0(7, _c1$1));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngModel", ctx.originalFilterModel.minValue);
        i0.ɵɵadvance(2);
        i0.ɵɵclassProp("inputError", _r3.errors == null ? null : _r3.errors.invalidRange);
        i0.ɵɵproperty("ngModel", ctx.originalFilterModel.maxValue);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", _r3.errors == null ? null : _r3.errors.invalidRange);
    } }, directives: [i2.NgIf, i1.ɵNgNoValidate, i1.NgControlStatusGroup, i1.NgForm, XpoRangeComparatorDirective, i1.NumberValueAccessor, i1.DefaultValueAccessor, i1.NgControlStatus, i1.NgModel, i2.NgForOf, XpoFacetFilerErrorComponent], styles: [".flex--stretch[_ngcontent-%COMP%]{flex:1}.xpo-FacetFilterRange-links[_ngcontent-%COMP%]{color:#1976d2;cursor:pointer;display:block}.xpo-FacetFilterRange-links[_ngcontent-%COMP%]:hover{color:#0d47a1}.xpo-FacetFilterRange-input[_ngcontent-%COMP%]{margin:5px 12px 0 0;height:30px;width:80px;border-radius:5%;border:1px solid #d8d8d8;padding:6px}.xpo-FacetFilterRange-input.inputError[_ngcontent-%COMP%]{border-color:#d32f2f}.xpo-FacetFilterRange[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, .xpo-FacetFilterRange[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}.xpo-FacetFilterRange[_ngcontent-%COMP%]   input[type=number][_ngcontent-%COMP%]{-moz-appearance:textfield}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoFacetFilterRangeNumberControlComponent, [{
        type: Component,
        args: [{
                selector: 'xpo-range-facet-filter',
                templateUrl: './filter-control-range.component.html',
                styleUrls: ['./filter-control-range.component.scss'],
                providers: [{ provide: XpoFilterControlBaseComponent, useExisting: forwardRef(() => XpoFacetFilterRangeNumberControlComponent) }],
            }]
    }], function () { return []; }, { rangeNumberForm: [{
            type: ViewChild,
            args: ['rangeNumberForm']
        }], filterModel: [{
            type: Input
        }] }); })();

class XpoFacetFilterQuickSearchControlComponent extends XpoFilterControlBaseComponent {
    constructor() {
        super();
        this.filterModel = '';
        this.hideTitleSection = true;
        this.allowInferDataFromSource = false;
        this.typeControl = XpoFacetFilterTypeControls.QuickSearch;
    }
    applyFilter() {
        this.onValueChanged(this.filterModel, this.mapFacetFilterControlToCriteria(this.filterModel));
    }
    onReset() {
        this.filterModel = '';
        this.applyFilter();
    }
    mapFacetFilterControlToCriteria(value) {
        return {
            filterId: '',
            type: XpoFacetFilterTypeOperator.String,
            conditions: [{ operator: XpoFacetFilterStringOperators.CONTAINS, value }],
            invalid: !this.isValidCondition()
        };
    }
    isValidCondition() {
        return this.filterModel.length > 0;
    }
    setModel() { }
    ;
}
XpoFacetFilterQuickSearchControlComponent.ɵfac = function XpoFacetFilterQuickSearchControlComponent_Factory(t) { return new (t || XpoFacetFilterQuickSearchControlComponent)(); };
XpoFacetFilterQuickSearchControlComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoFacetFilterQuickSearchControlComponent, selectors: [["xpo-quick-search-facet-filter"]], features: [i0.ɵɵProvidersFeature([{ provide: XpoFilterControlBaseComponent, useExisting: forwardRef(() => XpoFacetFilterQuickSearchControlComponent) }]), i0.ɵɵInheritDefinitionFeature], decls: 5, vars: 1, consts: [[1, "xpo-FacetFilterQuickSearch"], ["data-cy", "xpo-facet-quick-search", "appearance", "standard", 1, "xpo-FacetFilterQuickSearch-inputWrapper"], ["matInput", "", "autocomplete", "off", "placeholder", "Search", 3, "ngModel", "keyup", "ngModelChange", "change"], [1, "xpo-FacetFilterQuickSearch-inputIcon"]], template: function XpoFacetFilterQuickSearchControlComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "mat-form-field", 1);
        i0.ɵɵelementStart(2, "input", 2);
        i0.ɵɵlistener("keyup", function XpoFacetFilterQuickSearchControlComponent_Template_input_keyup_2_listener() { return ctx.applyFilter(); })("ngModelChange", function XpoFacetFilterQuickSearchControlComponent_Template_input_ngModelChange_2_listener($event) { return ctx.filterModel = $event; })("change", function XpoFacetFilterQuickSearchControlComponent_Template_input_change_2_listener() { return ctx.applyFilter(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "mat-icon", 3);
        i0.ɵɵtext(4, "search");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngModel", ctx.filterModel);
    } }, directives: [i3$2.MatFormField, i5.MatInput, i1.DefaultValueAccessor, i1.NgControlStatus, i1.NgModel, i4$1.MatIcon], styles: [".flex--stretch{flex:1}.xpo-FacetFilterQuickSearch-inputWrapper{position:relative!important;display:flex!important;margin-bottom:0!important;height:100%;align-items:center}.xpo-FacetFilterQuickSearch-inputWrapper .mat-form-field-wrapper{width:100%}.xpo-FacetFilterQuickSearch-inputIcon{color:#bdbdbd}\n"], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoFacetFilterQuickSearchControlComponent, [{
        type: Component,
        args: [{
                selector: 'xpo-quick-search-facet-filter',
                templateUrl: './filter-control-quick-search.component.html',
                styleUrls: ['./filter-control-quick-search.component.scss'],
                encapsulation: ViewEncapsulation.None,
                providers: [{ provide: XpoFilterControlBaseComponent, useExisting: forwardRef(() => XpoFacetFilterQuickSearchControlComponent) }],
            }]
    }], function () { return []; }, null); })();

const _c0 = ["rangeTimeForm"];
function XpoFacetFilterRangeTimeControlComponent_app_error_facet_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "app-error-facet", 8);
} }
const _c1 = function () { return ["minValue", "maxValue"]; };
class XpoFacetFilterRangeTimeControlComponent extends XpoFilterControlBaseComponent {
    constructor() {
        super();
        this.typeControl = XpoFacetFilterTypeControls.RangeMinMax;
        this.allowInferDataFromSource = false;
        this.filterModel = {
            minValue: { hour: undefined, minutes: undefined },
            maxValue: { hour: undefined, minutes: undefined },
        };
    }
    get timeFrom() {
        var _a, _b, _c, _d, _e, _f;
        return `${(_c = (_b = (_a = this.filterModel) === null || _a === void 0 ? void 0 : _a.minValue) === null || _b === void 0 ? void 0 : _b.hour) === null || _c === void 0 ? void 0 : _c.toString().padStart(2, '0')}:${(_f = (_e = (_d = this.filterModel) === null || _d === void 0 ? void 0 : _d.minValue) === null || _e === void 0 ? void 0 : _e.minutes) === null || _f === void 0 ? void 0 : _f.toString().padStart(2, '0')}`;
    }
    get timeTo() {
        var _a, _b, _c, _d, _e, _f;
        return `${(_c = (_b = (_a = this.filterModel) === null || _a === void 0 ? void 0 : _a.maxValue) === null || _b === void 0 ? void 0 : _b.hour) === null || _c === void 0 ? void 0 : _c.toString().padStart(2, '0')}:${(_f = (_e = (_d = this.filterModel) === null || _d === void 0 ? void 0 : _d.maxValue) === null || _e === void 0 ? void 0 : _e.minutes) === null || _f === void 0 ? void 0 : _f.toString().padStart(2, '0')}`;
    }
    set timeFrom(value) {
        this.filterModel.minValue.hour = +`${value.substring(0, 2)}`;
        this.filterModel.minValue.minutes = +`${value.substring(3, 5)}`;
    }
    set timeTo(value) {
        this.filterModel.maxValue.hour = +`${value.substring(0, 2)}`;
        this.filterModel.maxValue.minutes = +`${value.substring(3, 5)}`;
    }
    ngOnInit() {
        super.checkInit();
        this.originalFilterModel = cloneDeep(this.filterModel);
    }
    setModel(model) {
        this.filterModel = model;
        this.originalFilterModel = cloneDeep(this.filterModel);
    }
    applyFilter() {
        var _a, _b, _c, _d;
        if (!((_b = (_a = this.rangeTimeForm) === null || _a === void 0 ? void 0 : _a.form) === null || _b === void 0 ? void 0 : _b.pristine) && !((_d = (_c = this.rangeTimeForm) === null || _c === void 0 ? void 0 : _c.form) === null || _d === void 0 ? void 0 : _d.valid)) {
            return;
        }
        this.onValueChanged(this.filterModel, this.mapFacetFilterControlToCriteria(cloneDeep(this.filterModel)));
    }
    validateKey($event) {
        if ($event.code === 'Enter') {
            this.applyFilter();
        }
    }
    onReset() {
        var _a, _b;
        this.filterModel = cloneDeep(this.originalFilterModel);
        (_b = (_a = this.rangeTimeForm) === null || _a === void 0 ? void 0 : _a.form) === null || _b === void 0 ? void 0 : _b.markAsPristine();
        this.applyFilter();
    }
    mapFacetFilterControlToCriteria(val) {
        const operator = XpoFacetFilterNumberOperators.BETWEEN;
        return {
            filterId: this.filterId,
            type: XpoFacetFilterTypeOperator.XpoFacetFilterTimeValueOperator,
            conditions: [{ operator, value: val.minValue, valueTo: val.maxValue }],
            invalid: !this.isValidCondition(),
        };
    }
    isValidCondition() {
        var _a, _b, _c, _d;
        return (((_a = this.filterModel.maxValue) === null || _a === void 0 ? void 0 : _a.hour) !== undefined && ((_b = this.filterModel.minValue) === null || _b === void 0 ? void 0 : _b.hour) !== undefined
            && ((_c = this.filterModel.maxValue) === null || _c === void 0 ? void 0 : _c.minutes) !== undefined && ((_d = this.filterModel.minValue) === null || _d === void 0 ? void 0 : _d.minutes) !== undefined);
    }
}
XpoFacetFilterRangeTimeControlComponent.ɵfac = function XpoFacetFilterRangeTimeControlComponent_Factory(t) { return new (t || XpoFacetFilterRangeTimeControlComponent)(); };
XpoFacetFilterRangeTimeControlComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoFacetFilterRangeTimeControlComponent, selectors: [["xpo-time-range-facet-filter"]], viewQuery: function XpoFacetFilterRangeTimeControlComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.rangeTimeForm = _t.first);
    } }, inputs: { filterModel: "filterModel" }, features: [i0.ɵɵProvidersFeature([{ provide: XpoFilterControlBaseComponent, useExisting: forwardRef(() => XpoFacetFilterRangeTimeControlComponent) }]), i0.ɵɵInheritDefinitionFeature], decls: 8, vars: 7, consts: [[1, "xpo-FacetFilterRange"], [3, "rangeValidation"], ["rangeTimeForm", "ngForm"], ["type", "time", "name", "minValue", 1, "xpo-FacetFilterRange-input", 3, "ngModel", "ngModelChange"], ["minValue", "ngModel"], ["type", "time", "name", "maxValue", 1, "xpo-FacetFilterRange-input", 3, "ngModel", "ngModelChange"], ["maxValue", "ngModel"], ["errorMessage", "Invalid Range", 4, "ngIf"], ["errorMessage", "Invalid Range"]], template: function XpoFacetFilterRangeTimeControlComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "form", 1, 2);
        i0.ɵɵelementStart(3, "input", 3, 4);
        i0.ɵɵlistener("ngModelChange", function XpoFacetFilterRangeTimeControlComponent_Template_input_ngModelChange_3_listener($event) { return ctx.timeFrom = $event; })("ngModelChange", function XpoFacetFilterRangeTimeControlComponent_Template_input_ngModelChange_3_listener() { return ctx.applyFilter(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "input", 5, 6);
        i0.ɵɵlistener("ngModelChange", function XpoFacetFilterRangeTimeControlComponent_Template_input_ngModelChange_5_listener($event) { return ctx.timeTo = $event; })("ngModelChange", function XpoFacetFilterRangeTimeControlComponent_Template_input_ngModelChange_5_listener() { return ctx.applyFilter(); });
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(7, XpoFacetFilterRangeTimeControlComponent_app_error_facet_7_Template, 1, 0, "app-error-facet", 7);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r2 = i0.ɵɵreference(6);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("rangeValidation", i0.ɵɵpureFunction0(6, _c1));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngModel", ctx.timeFrom);
        i0.ɵɵadvance(2);
        i0.ɵɵclassProp("inputError", _r2.errors == null ? null : _r2.errors.invalidRange);
        i0.ɵɵproperty("ngModel", ctx.timeTo);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", _r2.errors == null ? null : _r2.errors.invalidRange);
    } }, directives: [i1.ɵNgNoValidate, i1.NgControlStatusGroup, i1.NgForm, XpoRangeComparatorDirective, i1.DefaultValueAccessor, i1.NgControlStatus, i1.NgModel, i2.NgIf, XpoFacetFilerErrorComponent], styles: [".flex--stretch[_ngcontent-%COMP%]{flex:1}.xpo-FacetFilterRange-input[_ngcontent-%COMP%]{font-family:\"Roboto\",\"Helvetica Neue\",Arial,sans-serif;margin:5px 12px 0 0;height:30px;width:110px;border-radius:5%;border:1px solid #d8d8d8;padding:6px 2px 6px 6px}.xpo-FacetFilterRange-input.inputError[_ngcontent-%COMP%]{border-color:#d32f2f}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoFacetFilterRangeTimeControlComponent, [{
        type: Component,
        args: [{
                selector: 'xpo-time-range-facet-filter',
                templateUrl: './filter-control-time-range.component.html',
                styleUrls: ['./filter-control-time-range.component.scss'],
                providers: [{ provide: XpoFilterControlBaseComponent, useExisting: forwardRef(() => XpoFacetFilterRangeTimeControlComponent) }],
            }]
    }], function () { return []; }, { rangeTimeForm: [{
            type: ViewChild,
            args: ['rangeTimeForm']
        }], filterModel: [{
            type: Input
        }] }); })();

class XpoFacetFilterModule {
}
XpoFacetFilterModule.ɵfac = function XpoFacetFilterModule_Factory(t) { return new (t || XpoFacetFilterModule)(); };
XpoFacetFilterModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: XpoFacetFilterModule });
XpoFacetFilterModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            MatCheckboxModule,
            MatRadioModule,
            MatFormFieldModule,
            MatInputModule,
            MatDatepickerModule,
            FormsModule,
            XpoIconModule,
            XpoDialogModule,
            XpoButtonModule,
            XpoDatePickerModule,
            XpoChipsModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoFacetFilterModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    MatCheckboxModule,
                    MatRadioModule,
                    MatFormFieldModule,
                    MatInputModule,
                    MatDatepickerModule,
                    FormsModule,
                    XpoIconModule,
                    XpoDialogModule,
                    XpoButtonModule,
                    XpoDatePickerModule,
                    XpoChipsModule
                ],
                declarations: [
                    XpoFacetFilterComponent,
                    XpoFacetFilterSection,
                    XpoFacetFilterEnumControlComponent,
                    XpoFacetFilterOptionControlComponent,
                    XpoFacetFilterRangeNumberControlComponent,
                    XpoFacetFilterQuickSearchControlComponent,
                    XpoFacetFilterEnumShowMoreDialogComponent,
                    XpoFacetFilterEnumOptionComponent,
                    XpoFacetFilterDateRangeControlComponent,
                    XpoFacetFilterRangeTimeControlComponent,
                    XpoRangeComparatorDirective,
                    XpoFacetFilerErrorComponent,
                ],
                exports: [
                    XpoFacetFilterComponent,
                    XpoFacetFilterSection,
                    XpoFacetFilterEnumControlComponent,
                    XpoFacetFilterOptionControlComponent,
                    XpoFacetFilterRangeNumberControlComponent,
                    XpoFacetFilterQuickSearchControlComponent,
                    XpoFacetFilterEnumOptionComponent,
                    XpoFacetFilterDateRangeControlComponent,
                    XpoFacetFilterRangeTimeControlComponent,
                ],
                entryComponents: [XpoFacetFilterEnumShowMoreDialogComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(XpoFacetFilterModule, { declarations: [XpoFacetFilterComponent,
        XpoFacetFilterSection,
        XpoFacetFilterEnumControlComponent,
        XpoFacetFilterOptionControlComponent,
        XpoFacetFilterRangeNumberControlComponent,
        XpoFacetFilterQuickSearchControlComponent,
        XpoFacetFilterEnumShowMoreDialogComponent,
        XpoFacetFilterEnumOptionComponent,
        XpoFacetFilterDateRangeControlComponent,
        XpoFacetFilterRangeTimeControlComponent,
        XpoRangeComparatorDirective,
        XpoFacetFilerErrorComponent], imports: [CommonModule,
        MatCheckboxModule,
        MatRadioModule,
        MatFormFieldModule,
        MatInputModule,
        MatDatepickerModule,
        FormsModule,
        XpoIconModule,
        XpoDialogModule,
        XpoButtonModule,
        XpoDatePickerModule,
        XpoChipsModule], exports: [XpoFacetFilterComponent,
        XpoFacetFilterSection,
        XpoFacetFilterEnumControlComponent,
        XpoFacetFilterOptionControlComponent,
        XpoFacetFilterRangeNumberControlComponent,
        XpoFacetFilterQuickSearchControlComponent,
        XpoFacetFilterEnumOptionComponent,
        XpoFacetFilterDateRangeControlComponent,
        XpoFacetFilterRangeTimeControlComponent] }); })();

var XpoFacetFilterEFieldModel;
(function (XpoFacetFilterEFieldModel) {
    XpoFacetFilterEFieldModel[XpoFacetFilterEFieldModel["ClientSide"] = 0] = "ClientSide";
    XpoFacetFilterEFieldModel[XpoFacetFilterEFieldModel["ServerSide"] = 1] = "ServerSide";
})(XpoFacetFilterEFieldModel || (XpoFacetFilterEFieldModel = {}));

/**
 * Generated bundle index. Do not edit.
 */

export { XpoFacetFilterCombiner, XpoFacetFilterComponent, XpoFacetFilterDateOperators, XpoFacetFilterDateRangeControlComponent, XpoFacetFilterEFieldModel, XpoFacetFilterEnumControlComponent, XpoFacetFilterEnumOptionComponent, XpoFacetFilterModule, XpoFacetFilterNumberOperators, XpoFacetFilterOptionControlComponent, XpoFacetFilterQuickSearchControlComponent, XpoFacetFilterRangeNumberControlComponent, XpoFacetFilterRangeTimeControlComponent, XpoFacetFilterSection, XpoFacetFilterSortOptions, XpoFacetFilterStringOperators, XpoFacetFilterTypeControls, XpoFacetFilterTypeOperator, XpoFilterControlBaseComponent };
